export const CHATGPT_OAUTH_CLIENT_ID = 'CHATGPT_CLIENT_ID';

export const OAUTH_PATH_SESSION_STORAGE_KEY = 'OAUTH_PATH_SESSION_STORAGE_KEY';

export const isOAuthPath = (path: string) =>
  new URL(path, window.location.origin).pathname === '/oauth/authorize';

export const getStoredOAuthParams = ():
  | { clientId: string; state: string; redirectUrl: string }
  | undefined => {
  const oAuthPath = window.sessionStorage.getItem(OAUTH_PATH_SESSION_STORAGE_KEY);
  if (!oAuthPath) return undefined;

  const query = new URL(oAuthPath, window.location.origin).searchParams;
  const clientId = query.get('client_id');
  const state = query.get('state');
  const redirectUrl = query.get('redirect_uri');
  const hasAllParams = !!clientId && !!state && !!redirectUrl;
  if (!hasAllParams) return undefined;

  return { clientId, state, redirectUrl };
};

export const getOAuthClientLabel = (clientId: string) =>
  clientId === CHATGPT_OAUTH_CLIENT_ID ? 'ChatGPT' : undefined;
